import {connect}    from 'react-redux';
import dataThunks   from '../../store/actions/dataThunks';
import getTemplates from '../../store/selectors/getTemplates';

const mapStateToProps = (state) => ({
  isLoading : state.getIn(['calendar', 'isLoading']),
  calendar  : state.getIn(['calendar','calendar']),
  lang      : getTemplates(state),
});

const mapDispatchToProps = (dispatch) => ({
  getCalendar(){
    dispatch(dataThunks.getCalendar());
  },
});

const buildController = (component) => connect(mapStateToProps, mapDispatchToProps)(component);

export default buildController;



// WEBPACK FOOTER //
// ./src/organisms/MainCalendar/MainCalendarController.js